import React, { useEffect, useState } from 'react';
import * as DateFns from 'date-fns';

import EventsDay from './EventDay/EventsDay';
import AddButton from '../AddButton/AddButton';
import { GAME, NUMBER_OF_WEEK_DAYS } from '../../../config/constants';
import { isCC, isNCAAAllSports, isTA } from '../../../helpers';
import { useSchedule } from '../../../helpers/customHooks';
import { useUserState } from '../../../store/hooks';
import { MonthCalendarPropsType } from './types';
import { ScheduleEvent } from '../../../config/commonTypes';
import { useLocation } from 'react-router-dom';

const MonthCalendar = ({ events, selectedDate }: MonthCalendarPropsType) => {

  const user = useUserState();
  // const [showToolTip, setShowToolTip] = useState(-1);
  const [dayAddButton, setDayAddButton] = useState<Date | null>(null);
  const [monthStart, startDate, endDate, currentDate] = useSchedule(selectedDate);

  const rows = [];
  const update = new URLSearchParams(useLocation().search).get('today');
  let days = [], day = startDate, week = 0, eventsDay: ScheduleEvent[];
  const handleOnMouseOver = (calendarDay: Date) => {
    if (!dayAddButton || !DateFns.isSameDay(calendarDay, dayAddButton)) {
      setDayAddButton(calendarDay);
    }
  };
  const element = document.getElementById("today");
  useEffect(() => {
    if(element){
      element.scrollIntoView({behavior: "smooth"});
    }
  }, [element, update]);

  while (day <= endDate) {
    for (let i = 0; i < NUMBER_OF_WEEK_DAYS; i++) {
      const cloneDay = day;
      eventsDay = events.filter(event => DateFns.isSameDay(cloneDay, new Date(event.startTime)));
      eventsDay.sort((a, b) => {
        if (a.type !== b.type) { // games first then practices
          return a.type.localeCompare(b.type);
        }
        if (a.type === GAME && b.type === GAME) { // first my games
          return +(b.homeTeamAbbr === user.teamShort || b.visitorTeamAbbr === user.teamShort);
        }
        return a.startTime - b.startTime; // finally order by start time
      });
      days.push(
        <div
          className={`month-row-cell ${
            !DateFns.isSameMonth(day, monthStart)
              ? 'month-row-cell-disabled'
              : DateFns.isSameDay(day, currentDate) ? 'month-row-cell-selected' : ''
          }`}
          key={day.toString()}
          onMouseOver={_ => handleOnMouseOver(cloneDay)}
          id={`${
            !DateFns.isSameMonth(day, monthStart)
              ? null
              : DateFns.isSameDay(day, currentDate) ? "today" : null}`}
        >
          <div
            className={'month-cell-day ' +
            (!DateFns.isSameMonth(day, monthStart) ?
              'month-cell-day-no-month' :
              DateFns.isToday(day) ?
                'month-cell-day-today' :
                DateFns.isPast(day) ?
                  'month-cell-day-past' : '')}
          >
            {DateFns.format(new Date(day), 'd')}</div>
          <EventsDay
            isFirstWeek={week <= 1}
            events={eventsDay}
            // day={day} // not used
            // showToolTip={showToolTip} // not used
            // setShowToolTip={setShowToolTip} // not used
          />
          {DateFns.isFirstDayOfMonth(day) && (
            <div
              className={'month-row-cell-first-day'}
              style={!DateFns.isSameMonth(day, monthStart) ? { color: 'gray' } : undefined}
            >
              {DateFns.format(new Date(day), 'MMMM')}
            </div>
          )}
          <AddButton
            display={(DateFns.isSameDay(cloneDay, dayAddButton || 0) && (isCC(user) || isTA(user) || isNCAAAllSports(user)) && (DateFns.isFuture(cloneDay) || DateFns.isToday(cloneDay)))}
            day={cloneDay}
            month
          />
        </div>
      );
      day = DateFns.addDays(day, 1);
    }
    rows.push(days);
    week++;
    days = [];
  }

  return <>{rows}</>;
};

export default MonthCalendar;
